import React, { useCallback, useEffect, useState } from 'react'
import { Button, Chip, Divider, FormLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { Code } from '@mantine/core';
import { getLobSplitKeys, getRootSplitKeys, postLobSplitKeys } from '../../services/integrationService';
import "ace-builds/src-min-noconflict/ext-language_tools";
import 'ace-builds/src-noconflict/theme-github'
import { RootEntitySplitKeyOptions, RootEntitySplitKeysMetadata, SplitKeyConfig, popupType } from "../../types/types"
import { GenericPopUp } from '../../components/popup/genericPopUp';


function SplitKeySummaryPage(props: { summary: SplitKeyConfig[],submit?:boolean }) {

  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage, setGenericMessage] = useState("");

  const openPopup = (message: string, type: popupType) => {
    setPopupType(type)
    setGenericMessage(message)
    setOpenGenericModal(true)
}

  async function handleClick(){
    const response = await postLobSplitKeys(props.summary)
    if(response.status ===200 || response.status ===201){
      openPopup(`Saved Successfully!`, "Success")
    }else {
      openPopup(`Failed to save, please try again.`, "Error")
    }
  }
  
  return (<>
      <GenericPopUp message={genericMessage}
            type={popupType}
            openGenericModal={openGenericModal}
            setOpenGenericModal={() => setOpenGenericModal(c => {
                window.location.reload();
                return false;
            })}
        />
    {(props.summary).map((splitKey:SplitKeyConfig) =>
      (!splitKey.domainType || splitKey.domainType !== "splitkeysoptions") &&
      <div key={splitKey.domainType+""}>
        <Chip size='small' label={splitKey.domainType} color={'primary'} variant={'filled'} className="splitkey-chip-entity" />
        <Code block className="splitkey-codeStyle" spellCheck={false}>{JSON.stringify(splitKey.domainValues, null, 2)}</Code>
      </div>
    )}
    {props.submit && <Button variant='outlined' style={{color: "#b11180"}} onClick={handleClick}>Submit</Button>}
  </>)
}

export function ShowLobSummaryPage() {
  const [lobSplitKeys, setLobSplitKeys] = useState<SplitKeyConfig[]>([]);
  const fetchLobSplitKeys = useCallback(async () => {
    getLobSplitKeys().then((response) => {
      const splitKeys:SplitKeyConfig[] = response.data.features.map((splitKey: any) => { return { "id": splitKey.id, "domainName": splitKey.domainName, "domainType": splitKey.domainType, "domainValues": splitKey.domainValues } })
      setLobSplitKeys(splitKeys);
    })
  }, [])

  useEffect(() => {
    fetchLobSplitKeys();
  }, [fetchLobSplitKeys])

  return (
    <div style={{ padding: "5%" }}>
      {lobSplitKeys.length > 0 && <SplitKeySummaryPage summary={lobSplitKeys}/>}
    </div>
  )
}

export default function SplitKeyConfigPage() {

  const [rootSplitKeys, setRootSplitKeys] = useState<RootEntitySplitKeysMetadata[]>([]);
  const [selectedSplitKey, setSelectedSplitKey] = useState<SplitKeyConfig[]>([]);
  const [lobSplitKeys, setLobSplitKeys] = useState<SplitKeyConfig[]>([]);
  
  const [index, setIndex] = useState(0);

  const fetchLobSplitKeys:()=>Promise<SplitKeyConfig[]> = useCallback(async () => {
    return getLobSplitKeys().then((response) => {
      const result = response.data.features.map((splitKey: any) => { return { "domainName": splitKey.domainName, "domainType": splitKey.domainType, "domainValues": splitKey.domainValues } })
      return result;
    }).catch((error) => {
      return [];
    })
  }, [])

  const fetchRootSplitKeys:()=>Promise<RootEntitySplitKeysMetadata[]> = useCallback(async () => {
    const response = await getRootSplitKeys(true);
    return (Object.values(response.features[0].domainValues[0]))
  }, [])

  useEffect(() => {
    (async () => {
      const lobSplitKeysresult = await fetchLobSplitKeys();
      setLobSplitKeys(lobSplitKeysresult)
      const rootSplitKeys = await fetchRootSplitKeys();
      setRootSplitKeys(rootSplitKeys.filter((splitKey)=>!lobSplitKeysresult.find((lobSplitKey)=>lobSplitKey.domainType===splitKey.name)))
    })()
  }, [fetchLobSplitKeys,fetchRootSplitKeys])

  function handleEntitySelection(domainType: string, domainValues: any) {
    setSelectedSplitKey([...selectedSplitKey.filter((splitKey: any) => splitKey.domainType !== domainType), { domainType, domainValues, domainName: "splitkeys" }])
  }

  return (
    <div style={{ padding: "5%" }}>
      {rootSplitKeys.map((splitKeyMetadata, idx) =>
        <div key={splitKeyMetadata.name} style={{ display: index===idx ? "block" : "none" }}>
          <EntitySplitKeyPage response={splitKeyMetadata} index={index} setIndex={setIndex} handleNext={handleEntitySelection}/>
        </div>
      )}
      {rootSplitKeys.length===0 ? <SplitKeySummaryPage summary={lobSplitKeys}/> : index===rootSplitKeys.length &&  <SplitKeySummaryPage summary={selectedSplitKey} submit={true} />}
    </div>
  )
}


function EntitySplitKeyPage(props: {
  response: RootEntitySplitKeysMetadata,
  index: number,
  setIndex: React.Dispatch<React.SetStateAction<number>>,
  handleNext: (name: string, selectedSplitKey: any) => void,
}) {

  const entityData = props.response;

  const [selectedSplitKey, setSelectedSplitKey] = useState<string>("");
  
  function handleClick() {
    if (selectedSplitKey === "") {
      alert("Please select a split key")
      return;
    }
    props.handleNext(entityData.name, JSON.parse(selectedSplitKey));
    props.setIndex(index => index + 1);
  }
  return (
    <>
      <Typography variant='h2' component={"h2"} display="block">{entityData.name}</Typography>
      <Typography variant="subtitle2" display="block" gutterBottom>{entityData.description}</Typography>
      <Divider style={{ margin: "30px 0px" }} />
      <RadioGroup
        value={selectedSplitKey}
        name={entityData.name}
        onChange={(event) => {
          setSelectedSplitKey(event.target.value);
        }}
      >
        {entityData.data.map((option:RootEntitySplitKeyOptions, idx: number) =>
          <SplitKeyOption data={option} key={idx} />
        )}
      </RadioGroup>
      { props.index !==0 && <Button style={{ marginRight: "10px",color: "#b11180" }} variant={"outlined"} color='inherit' onClick={() => props.setIndex(index => index - 1)}>Previous</Button>}
      <Button style={{ marginRight: "10px",color: "#b11180" }} variant={"outlined"} color='inherit' onClick={handleClick}>Next</Button>
    </>
  )
}


function SplitKeyOption(props: { data: RootEntitySplitKeyOptions }) {

  const data = props.data;

  return (
    <FormLabel style={{ display: "flex", alignItems: "start", marginBottom: "40px" }}>
      <Radio value={data.config} />
      <div>
        <Chip size='small' label={data.id} color={'secondary'} variant={'filled'} className="splitkey-chip-secondary" />
        <Chip size='small' label={data.description} color={'default'} variant={'filled'} className="splitkey-chip" />
        <Typography variant="body2" display="block" style={{ margin: "4px 0px" }}>{data.description2}</Typography>
      </div>
    </FormLabel>
  )
}